module.exports = __webpack_public_path__ + "img/burger.b47002d3.svg";